import { useEffect, useState } from "react";
import { SelectElement } from "../../../components/selectElement2";
import { serverApi } from "../../../api";

const inputStyle = {
    width: '100%', padding: '11px 12px', borderRadius: 10,
    border: '1.5px solid #cbd5e1', marginTop: 4,
    boxSizing: 'border-box', fontSize: 14, background: 'white',
    outline: 'none', color: '#0f172a',
};

const labelStyle = { fontSize: 12, fontWeight: 700, color: '#475569' };

const initialForm = {
    ideUbicacion: '',
    codigoUbicacion: '',
    uidModuloClase: '',
    recibeTraslados: false,
    modulo: ''
};

export const CrearModuloModal = ({ show, onClose, onSave, ubicaciones }) => {

    const [errors, setErrors] = useState({});
    const [moduloClases, setModuloClases] = useState([]);
    const [form, setForm] = useState(initialForm);

    const resetForm = () => {
        setForm(initialForm);
        setErrors({});
    };

    useEffect(() => {
        if (!show) resetForm();
    }, [show]);

    useEffect(() => {
        if (!show) return;

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad) return;

        const loadModulo = async () => {
            try {
                const resp = await serverApi.post(`/modulos/select-moduloClases`, { codigoEntidad });
                const opciones = resp.data.clases.map((item) => ({ value: item.uidModuloClase, label: item.moduloClase.toUpperCase() }));
                setModuloClases(opciones);
            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            }
        };

        loadModulo();
    }, [show]);

    const validateForm = () => {
        const newErrors = {};

        if (!form.ideUbicacion) {
            newErrors.ideUbicacion = 'Debe seleccionar una ubicación';
        }

        if (!form.uidModuloClase.trim()) {
            newErrors.uidModuloClase = 'Debe seleccionar una clase';
        }

        if (!form.modulo.trim()) {
            newErrors.modulo = 'Debe ingresar el nombre del modulo';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : name === 'modulo' ? value.toUpperCase() : value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleSelectUbicacion = (selected) => {
        setForm(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            codigoUbicacion: selected.data
        }));

        setErrors(prev => ({
            ...prev,
            ideUbicacion: ''
        }));
    };

    const handleSelectModuloClases = (selected) => {
        setForm(prev => ({
            ...prev,
            uidModuloClase: selected.value,
        }));

        setErrors(prev => ({
            ...prev,
            uidModuloClase: ''
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        onSave({ ...form, modulo: form.modulo.toUpperCase() });
    };

    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff', borderRadius: 24, width: '100%',
                maxWidth: 620, maxHeight: '92vh', overflowY: 'auto',
                boxShadow: '0 25px 60px rgba(0,0,0,0.25)', border: '1px solid #e2e8f0',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
                    padding: '20px 26px', color: 'var(--color-primario-contraste)',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    position: 'sticky', top: 0, zIndex: 1,
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 44, height: 44, borderRadius: 14,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 20,
                        }}>
                            <i className="fa-solid fa-cubes"></i>
                        </div>
                        <div>
                            <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18 }}>
                                Crear módulo
                            </h4>
                            <p style={{ margin: '3px 0 0', opacity: 0.85, fontSize: 12.5 }}>
                                Agrega un nuevo módulo a la sede seleccionada
                            </p>
                        </div>
                    </div>
                    <button type="button" onClick={onClose} style={{
                        background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
                        width: 34, height: 34, borderRadius: '50%', fontSize: 16, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}><i className="fa-solid fa-xmark"></i></button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: 26 }}>

                    <div className="row g-3" style={{ marginBottom: 8 }}>

                        <div className="col-12">
                            <label style={labelStyle}>Sede / Ubicación</label>
                            <div style={{ marginTop: 4 }}>
                                <SelectElement
                                    options={ubicaciones}
                                    name={`idUbicacion`}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    value={ubicaciones.find(u => u.value === form.ideUbicacion)}
                                    onChange={handleSelectUbicacion}
                                    isClearable={false}
                                    fontSize="13.5px"
                                />
                            </div>
                            {errors.ideUbicacion && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.ideUbicacion}
                                </div>
                            )}
                        </div>

                        <div className="col-12">
                            <label style={labelStyle}>Clase</label>
                            <div style={{ marginTop: 4 }}>
                                <SelectElement
                                    options={moduloClases}
                                    name={`uidModuloClase`}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    value={moduloClases.find(u => u.value === form.uidModuloClase)}
                                    onChange={handleSelectModuloClases}
                                    isClearable={false}
                                    fontSize="13.5px"
                                />
                            </div>
                            {errors.uidModuloClase && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.uidModuloClase}
                                </div>
                            )}
                        </div>

                        <div className="col-12">
                            <label style={labelStyle}>Módulo</label>
                            <input
                                name="modulo"
                                value={form.modulo}
                                onChange={handleChange}
                                placeholder="Ej: CAJA 1"
                                maxLength={20}
                                style={{
                                    ...inputStyle,
                                    textTransform: 'uppercase',
                                    borderColor: errors.modulo ? '#ef4444' : '#cbd5e1',
                                }}
                            />
                            {errors.modulo && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.modulo}
                                </div>
                            )}
                        </div>

                        <div className="col-12">
                            <label style={{ ...labelStyle, display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginTop: 6 }}>
                                <input
                                    type="checkbox"
                                    name="recibeTraslados"
                                    checked={form.recibeTraslados}
                                    onChange={handleChange}
                                    style={{ width: 18, height: 18, accentColor: 'var(--color-primario)', cursor: 'pointer' }}
                                />
                                Recibe traslados
                            </label>
                        </div>

                    </div>

                    {/* Botones */}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 26 }}>
                        <button type="button" onClick={onClose} style={{
                            padding: '12px 22px', borderRadius: 12, border: '1.5px solid #cbd5e1',
                            background: 'white', color: '#475569', fontWeight: 700, cursor: 'pointer', fontSize: 14,
                        }}>
                            Cancelar
                        </button>
                        <button type="submit" style={{
                            padding: '12px 28px', borderRadius: 12, border: 'none',
                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                            color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 14,
                            boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                            display: 'inline-flex', alignItems: 'center', gap: 8,
                        }}>
                            <i className="fa-solid fa-check"></i>
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
